import { render, staticRenderFns } from "./boots_item_shopee.vue?vue&type=template&id=80666c94"
import script from "./boots_item_shopee.vue?vue&type=script&lang=js"
export * from "./boots_item_shopee.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports